import { useEffect } from 'react';

import { TrackingService } from 'services/Tracking';
import { useStore } from 'store/storeUtils.js';

export const DATADOG_CONFIG = {
  applicationId: '80bb9923-f114-44d0-856c-8a1d4c8ef9b8',
  clientToken: 'pubdd1ed2a96c4070911aab665f388e8a53',
  site: 'datadoghq.eu',
  service: 'myform',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
};

const Tracking = () => {
  const store = useStore();

  useEffect(() => {
    if (!store.projectCode) return;

    TrackingService.getInstance().initializeTracking();
    if (!store.projectGTMCode) return;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const existingGtmScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${store.projectGTMCode}"]`);

    if (!existingGtmScript) {
      const script = document.createElement('script');
      script.innerHTML = `
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "${store.projectGTMCode}");
        `;
      script.async = true;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${store.projectGTMCode}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.appendChild(noscript);
    }
  }, [store.projectCode]);

  return null;
};

export default Tracking;
